/* =====================================================================
   HAGRO SALE COUNTDOWN — JavaScript
   =====================================================================
   Placering: assets/hagro-sale-countdown.js
   
   Features:
   - Live countdown (opdateres hvert sekund)
   - Auto-skjul af sektion ved deadline (eller vis "afsluttet"-besked)
   - Urgency-state ved < 24 timer (subtle accent farve)
   - Performance-friendly: pauses når section ikke er synlig
   - Add-to-cart fra produkt-cards (hvis cart drawer er installeret)
   ===================================================================== */
 
(function () {
  'use strict';
 
  class HagroSaleCountdown extends HTMLElement {
    constructor() {
      super();
      this.deadline = null;
      this.tickInterval = null;
      this.isVisible = false;
      this.showAfterEnd = this.dataset.showAfterEnd === 'true';
      
      this.daysEl = this.querySelector('[data-days]');
      this.hoursEl = this.querySelector('[data-hours]');
      this.minutesEl = this.querySelector('[data-minutes]');
      this.secondsEl = this.querySelector('[data-seconds]');
      this.countdownEl = this.querySelector('[data-countdown]');
      this.expiredEl = this.querySelector('[data-expired]');
      
      this._tick = this._tick.bind(this);
    }
 
    connectedCallback() {
      const deadlineStr = this.dataset.deadline;
      if (!deadlineStr) {
        console.warn('[HAGRO Sale] No deadline set');
        return;
      }
      
      this.deadline = new Date(deadlineStr).getTime();
      
      if (isNaN(this.deadline)) {
        console.error('[HAGRO Sale] Invalid deadline:', deadlineStr);
        return;
      }
      
      // Initial tick
      this._tick();
      
      // Setup IntersectionObserver to pause/resume timer when off-screen
      // Saves CPU on long pages
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            this.isVisible = entry.isIntersecting;
            if (this.isVisible) {
              this._startTicking();
            } else {
              this._stopTicking();
            }
          });
        }, { rootMargin: '100px' });
        
        this.observer.observe(this);
      } else {
        this._startTicking();
      }
    }
 
    disconnectedCallback() {
      this._stopTicking();
      if (this.observer) this.observer.disconnect();
    }
 
    _startTicking() {
      if (this.tickInterval) return;
      this.tickInterval = setInterval(this._tick, 1000);
    }
 
    _stopTicking() {
      if (this.tickInterval) {
        clearInterval(this.tickInterval);
        this.tickInterval = null;
      }
    }
 
    _tick() {
      const now = Date.now();
      const remaining = this.deadline - now;
      
      if (remaining <= 0) {
        this._handleExpired();
        return;
      }
      
      // Calculate time units
      const days = Math.floor(remaining / (1000 * 60 * 60 * 24));
      const hours = Math.floor((remaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((remaining % (1000 * 60)) / 1000);
      
      // Update DOM (zero-padded)
      if (this.daysEl) this.daysEl.textContent = String(days).padStart(2, '0');
      if (this.hoursEl) this.hoursEl.textContent = String(hours).padStart(2, '0');
      if (this.minutesEl) this.minutesEl.textContent = String(minutes).padStart(2, '0');
      if (this.secondsEl) this.secondsEl.textContent = String(seconds).padStart(2, '0');
      
      // Add urgency state when < 24 hours
      if (remaining < 24 * 60 * 60 * 1000) {
        this.countdownEl.classList.add('is-urgent');
      } else {
        this.countdownEl.classList.remove('is-urgent');
      }
    }
 
    _handleExpired() {
      this._stopTicking();
      
      if (this.showAfterEnd) {
        // Show expired state but keep section
        if (this.countdownEl) this.countdownEl.hidden = true;
        if (this.expiredEl) this.expiredEl.hidden = false;
      } else {
        // Hide entire section
        this.hidden = true;
      }
      
      // Dispatch event for tracking/analytics
      document.dispatchEvent(new CustomEvent('hagro:sale:expired', { 
        detail: { deadline: this.deadline }
      }));
    }
  }
 
  // Register custom element
  if (!customElements.get('hagro-sale-countdown')) {
    customElements.define('hagro-sale-countdown', HagroSaleCountdown);
  }
 
  // =====================================================================
  // ADD-TO-CART INTERCEPT for sale cards
  // (Only if cart drawer is installed — otherwise let form submit normally)
  // =====================================================================
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('.hagro-sale-card__form');
    if (!form) return;
    
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return; // No cart drawer = let normal submit happen
    
    // Cart drawer's own listener will handle this — we just need to NOT block it
    // The drawer's submit listener already intercepts all /cart/add forms
  });
 
})();